module.exports = __webpack_public_path__ + "static/media/sambapos.6f94b66e.png";